'use client';

import dynamic from 'next/dynamic';
import { useLearnData } from '../../../../context/LearnDataProvider';
import { CommonLearnBlockProps } from '../LearnBlock';

const LearningObjectivesBlock = dynamic(
  () => import('./LearningObjectivesBlock'),
);

/**
 * Wraps LearningObjectivesBlock so it can be lazy-loaded with next/dynamic.
 */
export default function LearningObjectivesWrapper(
  props: CommonLearnBlockProps,
): JSX.Element | null {
  const { learnData: clientLearnData } = useLearnData();
  const { sections: { learningObjectives = undefined } = {} } =
    clientLearnData || {};

  return learningObjectives ? (
    <LearningObjectivesBlock
      learningObjectives={learningObjectives}
      {...props}
    />
  ) : null;
}
